/**
 * contains a map
 */
export const ListsKeys = {
  HOME: "Home",
  DOCUMENTATION: "Documentation",
  USE_CASES: "Use Cases",
  INTEGRATION: "Integration",
  TUTORIAL: "Tutorial",
  SUPPORT: "Support",
  DASHBOARD: "Dashboard",
  APPLICATIONS: "ApplicationS",
  NODES: "Nodes",
  DATASETS: "Datasets",
  MODELS: "Models",
  FILES: "Files",
};

const _homeList = [
  {
    title: ListsKeys.DOCUMENTATION,
    subTitle: "Examples are user guides",
    icon: "documentation",
  },
  {
    title: ListsKeys.USE_CASES,
    subTitle: "Applications built by Averroes.AI",
    icon: "briefcase",
  },
  {
    title: ListsKeys.INTEGRATION,
    subTitle: "Integrate with Averroes",
    icon: "intersect",
  },

  {
    title: ListsKeys.TUTORIAL,
    subTitle: "Tutorial Averroes",
    icon: "lesson",
  },
  {
    title: ListsKeys.SUPPORT,
    subTitle: "We’re here to help",
    icon: "support",
  },
];

const _documentationList = [
  {
    title: ListsKeys.DASHBOARD,
    icon: "dashboard",
  },

  {
    title: ListsKeys.APPLICATIONS,
    icon: "tablet",
  },
  {
    title: ListsKeys.NODES,
    icon: "transform",
  },
  {
    title: ListsKeys.DATASETS,
    icon: "web-server",
  },
  {
    title: ListsKeys.MODELS,
    icon: "d-modeling",
  },
  {
    title: ListsKeys.FILES,
    icon: "file-sharing",
  },
];

/**
 * exported lists object
 */
export const lists = {
  [ListsKeys.HOME]: _homeList,
  [ListsKeys.DOCUMENTATION]: _documentationList,
};
